import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ReactNode, useState, createContext, useContext } from "react"
import { DashboardUser } from "@hydrologiq/common/providers/FirebaseAuth"

interface QueryProviderProps {
  children: ReactNode
  user?: DashboardUser
}

const UserContext = createContext<DashboardUser | undefined>(undefined)

export const useQueryUser = () => {
  return useContext(UserContext)
}

export const QueryProvider = ({ children, user }: QueryProviderProps) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            staleTime: 5 * 60 * 1000, // 5 minutes
            gcTime: 10 * 60 * 1000, // 10 minutes
            retry: (failureCount, error) => {
              // Don't retry on 4xx errors
              if (error instanceof Error && error.message.includes("4")) {
                return false
              }
              return failureCount < 3
            },
            refetchOnWindowFocus: false,
          },
        },
      })
  )

  return (
    <QueryClientProvider client={queryClient}>
      <UserContext.Provider value={user}>{children}</UserContext.Provider>
    </QueryClientProvider>
  )
}
